const authBasePrefix = `auth/`;
export const auth = {
  login: () => `${authBasePrefix}login`,
  twoFactor: () => `${authBasePrefix}2factor`,
  logout: () => `${authBasePrefix}logout`,
  recovery: () => `${authBasePrefix}recovery`,
};

export const misc = {
  contacts: () => '/metadata/contacts',
  dictionaries: () => '/metadata/dictionaries',
  status: () => `/user/me`,
  password: () => `/common/approve/password`,
};
const accountsBasePrefix = 'accounts/';
export const accounts = {
  account: () => `accounts`,
  transactions: (id: string) => `${accountsBasePrefix}${id}/transactions`,
  allTransactions: (id: string) => `${accountsBasePrefix}${id}/alltransactions`,
};

const paymentsBasePrefix = 'payments/';
export const payments = {
  checkLimit: () => `${paymentsBasePrefix}checklimit`,
  requisites: () => `${paymentsBasePrefix}requisites`,
  deleteRequisites: (id: string) => `${paymentsBasePrefix}requisites/${id}`,
  external: () => `${paymentsBasePrefix}external`,
  internal: () => `${paymentsBasePrefix}internal`,
};

const cardsBasePrefix = 'cards/';
export const cards = {
  cards: () => `${cardsBasePrefix}`,
  addCard: () => `${cardsBasePrefix}new`,
  topup: (cardId: string) => `${cardsBasePrefix}${cardId}/topup`,
  downloadStatement: (cardId: string, token: string) => `${cardsBasePrefix}${cardId}/statement/${token}`,
};

const messagesBasePrefix = 'messages';
export const messages = {
  getMessages: (type: string) => `${messagesBasePrefix}/${type}`,
  getNewMessagesInfo: () => `${messagesBasePrefix}/ping`,
  markAsRead: (messageId: string) => `${messagesBasePrefix}/${messageId}`,
  sendMessage: () => `${messagesBasePrefix}`,
};
